import { MarketApi, PersonalApi } from '@smartswap/client-api';
import { config } from '@/configuration';

export const marketApi = new MarketApi(config);
export const personalApi = new PersonalApi(config);
